/**
 * @author：
 * @update：
 * @description：
 **/
import CusPagination from '@/components/cusPagination.vue';
import {batchGoodsGet, batchGoodsGetNumbers,batchAuditPost} from "@/api/batchGoods"
import {fileEcho} from "@/api/url"

export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            fileEcho: fileEcho,
            searchForm: {
                name: '',//商品名称
                unionId: '',//商品id
                storeName: '',//所属店铺
                price: '',//价格区间
                deliveryMode: '',//运送方式
                state: '',//商品状态
                batchNumber: '',//批次号
                createdDate: [],//发布时间
            },
            cutCreatedDate: '',
            moneySectionOption: [
                {label: "0-1000元", value: "0,1000"},
                {label: "1001-2000元", value: "1001,2000"},
                {label: "2001-3000元", value: "2001,3000"},
                {label: "3001-4000元", value: "3001,4000"},
                {label: "4001-5000元", value: "4001,5000"},
                {label: "5001元以上", value: "5001"}
            ],
            transportOption: [
                {value: 'EXPRESS', label: '快递'},
                {value: 'ONLINE', label: '线上'},
                {value: 'DOWNLOAD', label: '下载'}
            ],
            goodsStateOption: [
                {value: 'ON_SALE', label: '出售中'},
                {value: 'HALT_SALE', label: '下架'},
                {value: 'VIOLATION_HALT_SALE', label: '违规下架'},
                {value: 'FOR_SALE', label: '上架'},
                {value: 'RESERVE', label: '待上架'},
                {value: 'CREATE', label: '新建'}
            ],
            tableLoading: false,
            tableData: [],//表格数据
            currentPage: 1,
            pageSize: 10,
            total: 0,
            auditDialog: false,//一键审核弹框
            auditSearch: '',//一键审核搜索
            batchData: [],//批次号数据
            batchSearchData:[],
            selBatchData: [],//已选择数量
            auditCurrentPage: 1,
            auditPageSize: 5,
            auditTotal: 0,
            innerVisible:false,//内层弹框
            opinion:'',//不通过原因
        };
    },
    // 自定义方法
    methods: {
        //搜索
        seachBtn() {
            this.currentPage = 1;
            this.getList();
        },
        //重置
        resetBtn() {
            this.searchForm.name = '';
            this.searchForm.unionId = '';
            this.searchForm.storeName = '';
            this.searchForm.price = '';
            this.searchForm.deliveryMode = '';
            this.searchForm.state = '';
            this.searchForm.batchNumber = '';
            this.searchForm.createdDate = '';
            this.cutCreatedDate = '';
            this.getList();
        },
        getList() {
            if (this.searchForm.createdDate.length > 0) {
                this.cutCreatedDate = (this.searchForm.createdDate[0] + ' 00:00:00' + "," + this.searchForm.createdDate[1] + ' 00:00:00')
            }
            this.tableLoading = true;
            this.$ajax.get(batchGoodsGet, {
                name: this.searchForm.name,
                unionId: this.searchForm.unionId,
                storeName: this.searchForm.storeName,
                price: this.searchForm.price,
                deliveryMode: this.searchForm.deliveryMode,
                state: this.searchForm.state,
                batchNumber: this.searchForm.batchNumber,
                createdDate: this.cutCreatedDate,
                pageSize: this.pageSize,
                pageNumber: this.currentPage
            }).then((res) => {
                if (res.status === 200) {// 成功了
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                    this.tableLoading = false;
                }
            }, (err) => {
                console.log(err);
            })
        },
        //详情
        details(row) {
            console.log(row);
            this.$router.push({path: '/goodsDetail', query: {id: row.id, type: 'Not'}});
        },

        //审核弹框
        auditClick() {
            this.auditDialog = true;
            this.getNumber()
        },
        //批次号弹框搜索
        auditSearchBtn() {
            this.auditCurrentPage = 1
            let newArr = this.batchSearchData.filter(
                item=>item.batchNumber.indexOf(this.auditSearch)>=0
            );
            console.log(newArr);
            this.batchData = newArr;
        },
        //批次号搜索清空
        auditSearchBtnClear(){
            this.getNumber();
            this.batchData = this.batchSearchData
        },
        //批次号数据
        getNumber() {
            this.$ajax.get(batchGoodsGetNumbers).then((res) => {
                if (res.status === 200) {// 成功了
                    this.batchData = res.data;
                    this.batchSearchData = res.data;
                }
            })
        },
        // 批次号数据显示列表分页
        handleSizeChange(val) {
            this.auditPageSize = val
            this.getNumber();
        },
        handleCurrentChange(val) {
            this.auditCurrentPage = val
            this.getNumber();
        },
        //批次号选择
        selClick(row) {
            if (this.selBatchData.indexOf(row) == -1) {
                this.selBatchData.push(row)
            }
            console.log(this.selBatchData);
        },
        //批次号清空
        clearBtn() {
            this.selBatchData = []
        },
        //单个删除
        delTr(item,index){
            console.log(item,index);
            this.selBatchData.splice(index,1)
            console.log(this.selBatchData)
        },
        //审核通过
        auditSubmit(){
            if (this.selBatchData.length == 0){
                this.$message.error('请选择审核的批次号');
            }else{
                let batchNumbers = []
                for (let i = 0; i < this.selBatchData.length; i++){
                    batchNumbers.push(this.selBatchData[i].batchNumber)
                }
                this.$ajax.post(batchAuditPost,{
                    pass:true,
                    batchNumbers:batchNumbers
                }).then((res) => {
                    if (res.status === 200) {// 成功了
                        this.auditDialog = false;
                        this.selBatchData = []
                        this.getList();
                    }
                },err=>{
                    console.log(err);
                    this.$message.error(err.data);
                })
            }
        },
        //审核拒绝
        auditCancel(){
            if (this.selBatchData.length == 0){
                this.$message.error('请选择审核的批次号');
            }else{
                this.innerVisible = true;
            }
        },
        innerSubmit(){
            if (this.opinion == ''){
                this.$message.error('请填写不通过原因');
            }else{
                let batchNumbers = []
                for (let i = 0; i < this.selBatchData.length; i++){
                    batchNumbers.push(this.selBatchData[i].batchNumber)
                }
                this.$ajax.post(batchAuditPost,{
                    pass:false,
                    opinion:this.opinion,
                    batchNumbers:batchNumbers
                }).then((res) => {
                    if (res.status === 200) {// 成功了
                        this.innerVisible = false;
                        this.auditDialog = false;
                        this.selBatchData = []
                        this.opinion = '';
                        this.getList();
                    }
                },err=>{
                    console.log(err);
                    this.$message.error(err.data);
                })
            }
        },
        innerCancel(){
            this.innerVisible = false;
            this.opinion = '';
        },
    },
    // 数据观察监听
    watch: {
        currentPage(newData, oldData) {
            this.getList()
        },
        pageSize(newData, oldData) {
            this.page = 1;
            this.getList()
        },
        auditDialog(newData, oldData){
            if (newData===false){
                this.selBatchData = []
            }
        }
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        this.getList();
    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
